import React, { Component } from 'react';
import { Button } from '@clockout-dev/design-elements';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import Page from '../common/page/Page';
import { SCOPES } from '../../constants/scopes.constants';
import NotificationsController from './notifications.controller';
import NotificationsTable from './elements/NotificationsTable';
import styles from './styles/notifications.module.scss';

/**
 * /notifications — admin feed of failed advances, failed settlements,
 * trouble tickets and support-ticket status changes. Gated by the same
 * scope the backend checks (`screen:support:view`).
 */
class Notifications extends Inherit(NotificationsController, Component) {
    render() {
        const { loading, loadError, items, pagination, typeTab, unreadOnly, timeFrame, dateRange } = this.state;

        return (
            <Page
                title={{ text: 'Notifications', highlight: '' }}
                scope={SCOPES.SUPPORT_VIEW}
                description="Failed advances and settlements, trouble tickets, and support ticket updates."
                notificationContextHolder={this.props.notificationContextHolder}
                action={
                    <Button
                        size="l"
                        variant="primary"
                        color="secondary"
                        fontWeight="semibold"
                        className={styles.refreshBtn}
                        onClick={this.handleRefresh.bind(this)}
                    >
                        Refresh
                    </Button>
                }
            >
                <NotificationsTable
                    typeTab={typeTab}
                    onTypeTabChange={(key) => this.handleTypeTabChange(key)}
                    unreadOnly={unreadOnly}
                    onUnreadOnlyChange={(checked) => this.handleUnreadOnlyChange(checked)}
                    timeFrame={timeFrame}
                    dateRange={dateRange}
                    onTimeFrameChange={(value) => this.handleTimeFrameChange(value)}
                    onDateRangeChange={(dates) => this.handleDateRangeChange(dates)}
                    dataSource={items}
                    loading={loading}
                    loadError={loadError}
                    pagination={pagination}
                    onChange={(pag) => this.handleTableChange(pag)}
                    onRowClick={(record) => this.handleRowClick(record)}
                />
            </Page>
        );
    }
}

export default withHooks(Notifications);
